import { useMemo } from 'react';
import { useApi } from '../infrastructure/useApi';
import { DEFAULT_API_OPTIONS } from '../infrastructure/defaults';
import { API_URLS } from '../apiUrls';
import { API_METHODS } from '../constants/apiMethods';

/**
 * Hook for accessing Contact API methods.
 *
 * Usage:
 * const { getCsrs, getCsrDetails, cancel } = useContactApi();
 * await getCsrs();
 *
 * Cancellation scope:
 * - cancel() applies to requests started by this hook instance.
 * - For independent cancellation scopes, create separate hook instances.
 */
export const useContactApi = (baseOptions = DEFAULT_API_OPTIONS) => {
	const { call, cancel } = useApi(baseOptions);

	return useMemo(
		() => ({
			getCsrs: () =>
				call({
					url: API_URLS.contact.getCsr(),
					method: API_METHODS.GET,
				}),

			getCsrDetails: ({ PlantCode, BillToCustomerNumber, ShipToNumber }) =>
				call({
					url: API_URLS.contact.getCsrDetail(),
					method: API_METHODS.POST,
					payload: {
						PlantCode,
						BillToCustomerNumber,
						ShipToNumber,
					},
				}),

			cancel,
		}),
		[call, cancel]
	);
};
